import React, {useEffect} from 'react';

import {useIntl} from 'react-intl';

import {AdaptiveTraining} from './AdaptiveTraining';
import {AdaptiveTrainingDetailed} from './AdaptiveTrainingDetailed';
import {CallToAction} from './CallToAction';
import {ClipItOnSection} from './ClipItOnSection';
import {HealthSection} from './HealthSection';
import {HeroSection} from './HeroSection';
import {InteractiveHardware} from './InteractiveHardware';
import {ProductShowcaseSection} from './ProductShowcaseSection';
import {RacingSection} from './RacingSection';
import {ThreeElements} from './ThreeElements';
import {VideoSection1} from './VideoSection1';
import {VideoSection2} from './VideoSection2';
import {VideoSection3} from './VideoSection3';
import {VideoSection4} from './VideoSection4';

export const Home: React.FC<React.PropsWithChildren<unknown>> = () => {
  const intl = useIntl();

  useEffect(() => {
    // Smooth scrolling for the entire page
    document.documentElement.style.scrollBehavior = 'smooth';

    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      {/* {intl.formatMessage({id: 'home.hero.description'})} */}
      <HeroSection />

      <ClipItOnSection />

      {/* {intl.formatMessage({id: 'home.threeElements.description'})} */}
      <ThreeElements />

      <ProductShowcaseSection />

      {/* {intl.formatMessage({id: 'home.interactiveHardware.description'})} */}
      <InteractiveHardware />

      {/* {intl.formatMessage({id: 'home.videoSection3.description'})} */}
      <VideoSection3 />

      {/* {intl.formatMessage({id: 'home.videoSection1.description'})} */}
      <VideoSection1 />

      {/* {intl.formatMessage({id: 'home.videoSection2.description'})} */}
      <VideoSection2 />

      {/* {intl.formatMessage({id: 'home.videoSection4.description'})} */}
      <VideoSection4 />

      {/* {intl.formatMessage({id: 'home.adaptiveTraining.description'})} */}
      <AdaptiveTraining />

      {/* {intl.formatMessage({id: 'home.adaptiveTrainingDetailed.description'})} */}
      <AdaptiveTrainingDetailed />

      <RacingSection />

      {/* {intl.formatMessage({id: 'home.healthSection.description'})} */}
      <HealthSection />

      {/* {intl.formatMessage({id: 'home.callToAction.description'})} */}
      <CallToAction />
    </div>
  );
};
